import { User } from "entities/user";
import { SanityChecker } from "entities/sanity_checker";

export type TeaAddonProblem = {
  id: number;
  key: Key;
  notes: string;
  state: string;
  title: string;
  created_at: Date | string;
  user: User;
  sanity_checker: SanityChecker;
};

export type Key =
  | "TeaAddonSubscriptionShouldExists"
  | "TeaAddonSubscriptionShouldBeCanceled"
  | "TeaAddonSubscriptionShouldBeActive"
  | "ActiveTeaAddonSubscriptionShouldHaveRenewalDate"
  | "TeaAddonSubscriptionShouldRenewOnTime"
  | "TeaAddonSubscriptionShouldBeCanceledForDeletedUsers"
  | "UserShouldNotBeChargedMultipleTimes"
  | "TeaAddonShouldExistForPaidInvoices"
  | "TeaAddonShouldBeAttachedToCorrectBox"
  | "TeaAddonShouldHaveCorrectChargebeeAddon"
  | "TeaAddonShouldBeLinkedToCorrectOrderInvoice"
  | "TeaAddonShouldNotBeCreatedForCanceledTeaAddonSubscription";

export const keys: Key[] = [
  "TeaAddonShouldExistForPaidInvoices",
  "TeaAddonSubscriptionShouldRenewOnTime",
];

const formatKeyLabel = (key: string): string => {
  return key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const selectKeys = keys.map((key) => {
  return { value: key, label: formatKeyLabel(key) };
});
